export default __webpack_public_path__ + "static/media/logo.3c6bbe46.jpg";